<div class="containerTest">
  <div class="text-center">
      <h1>Banned List of Emails</h1>
  </div>
  <hr>
  <div class="card">
      <div class="card-body" style="overflow-x:auto; max-width:800px;">
          <!-- Table -->
          <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="stripe hover row-border order-column">
              <!-- Head -->
              <thead>
                  <tr>
                      <th>Email</th>
                      <th>Banned</th>
                      <th>Actions</th>
                  </tr>
              </thead>

              <!-- Body -->
              <tbody>
                  <tr *ngFor="let ban of bans; index as i">
                      <td>{{ ban.email }}</td>
                      <td [attr.data-sort]="sortDate(ban.registered)">{{ ban.registered | date:'medium' }}</td>
                      <td class="td-actions">
                        <button (click)="removeBan(i)" class="btn-danger"><mdb-icon fas icon="trash"></mdb-icon></button>
                      </td>
                  </tr>
              </tbody>

              <!-- Foot -->
              <tfoot>
                <tr class="tr-new">
                  <td colspan="3">
                    <!-- Form -->
                    <form [formGroup]="form" (submit)="form.valid && onSubmit(f)" #f="ngForm" novalidate [class.disabled]="submitting">
                      <div class="input-group">
                        <!-- Email -->
                        <input type="email" class="form-control" placeholder="New email address..." formControlName="email"
                          [ngClass]="{ 'is-invalid': f.submitted && email.invalid }" required pattern="^[^@]+@[^@]+$">
                        <button type="submit" class="add-new custom btn btn-secondary" [disabled]="submitting">Add New</button>

                        <!-- Invalid Email -->
                        <div *ngIf="f.submitted && email.invalid" class="invalid-feedback">
                            <div class="mb-1" *ngIf="email.errors!.required">Email is required</div>
                            <div class="mb-1" *ngIf="email.errors!.pattern">Email is invalid</div>
                        </div>
                      </div>
                    </form>
                  </td>
                </tr>
              </tfoot>
          </table>
      </div>
  </div>
</div>
